import React from 'react';
import FolderManager from '../components/messages/FolderManager';

const SettingsFolders = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h2 className="folder-settings-title">📁 Folder Settings</h2>

      <FolderManager />
    </div>
  );
};

export default SettingsFolders;
